module.exports = __webpack_public_path__ + "static/media/admissions-infra-library.44a99ea5.jpg";